import * as React from "react";

import { Box, PlatformPageDialog } from "@platform/style";
import { MyWorkItemGrid } from "./MyWorkItemGrid";

export default function MyWorkItems() {
  return (
    <PlatformPageDialog
      title={"My Work Items"}
      eventName={"MyWorkItems"}
      showPageHeader={true}
      showCloseIcon={false}
      keepMounted={false}
    >
      <Box paddingTop={"24px"} height={"100%"} width={"100%"} overflow={"hidden"}>
        <MyWorkItemGrid />
      </Box>
    </PlatformPageDialog>
  );
}
